import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

class Information extends Component {

    constructor(props) {
        super(props);
        this.state = {
            temp_lang: ""
        };
    };

    componentWillMount() {
        this.setState({temp_lang: this.props.lang});
    }

    _close(){
        this.props.setLang(false);
    }

    _set(){
        this.props.setLang(this.state.temp_lang);
    }

    _renderText(item) {
        return langRegister.get("modal-lang", item, this.state.temp_lang);
    }

    render() {
        return (
            <div>
                <img onClick={() => this.setState({active: true})} className={Styles.infoIcon} src={require("../../assets/images/info_icon.svg")}/>
                {
                    this.state.active &&
                    <div className={Styles.overlay}>
                        <div className={Styles.overlayModal}>
                            <div className={Styles.overlayModalInner}>
                                <img onClick={() => this.setState({active:false})}
                                     className={Styles.overlayCloseButton}
                                     src={require("../../assets/images/close_icon.svg")}/>
                                <div>
                                    <div className={Styles.overlayModalTitle}>
                                        {this._renderText("item_1")}
                                    </div>
                                    <div className={Styles.overlayModalText}>
                                        <span className={Styles.overlayModalTextBold}>{this._renderText("item_4")}</span> {this._renderText("item_5")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.overlayModalButtons}>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div onClick={() => {this.setState({active:false})}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                        {this._renderText("item_3")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/components/information/component.js